// Plan coordinates use top-left x/y in metres; Three uses y for elevation.
export function planPoint(x, y, elevation = 0) { return [x, elevation, y]; }

export function bayBounds(fixture, index) {
  const weights = fixture.bays.map(b => Math.max(0, b.m || 0));
  const total = weights.reduce((a, b) => a + b, 0);
  const share = total ? weights[index] / total : 1 / weights.length;
  const offset = total ? weights.slice(0, index).reduce((a, b) => a + b, 0) / total : index / weights.length;
  return fixture.w >= fixture.h
    ? { x: fixture.x + fixture.w * offset, y: fixture.y, w: fixture.w * share, h: fixture.h }
    : { x: fixture.x, y: fixture.y + fixture.h * offset, w: fixture.w, h: fixture.h * share };
}

export function canWalk(x, z, plan, radius = .2) {
  if (x < radius || z < radius || x > plan.room.w - radius || z > plan.room.h - radius) return false;
  const inside = (a, b, w, h) => x > a - radius && x < a + w + radius && z > b - radius && z < b + h + radius;
  if (plan.fixtures.some(f => inside(f.x, f.y, f.w, f.h))) return false;
  for (const r of plan.rooms || []) {
    if (inside(r.x + r.w - .06, r.y, .12, r.h)) return false;
    if (inside(r.x, r.y + r.h - .06, r.w - .9, .12)) return false;
    // Desks, staff table/counter and amenities are solid too.
    if (r.kind === 'office' && inside(r.x + r.w * .25, r.y + r.h * .48 - .35, r.w * .6, .7)) return false;
    if (r.kind === 'staff' && inside(r.x + r.w * .5 - .75, r.y + r.h * .6 - .75, 1.5, 1.5)) return false;
  }
  return true;
}

// A single entry definition drives the frame, mat and initial customer viewpoint.
export function entryPose(plan) {
  const e = plan.room.entrance;
  return e.side === 'bottom'
    ? { x: e.x + e.w / 2, z: e.y - .4, yaw: 0 }
    : { x: e.x - .4, z: e.y + e.w / 2, yaw: -Math.PI / 2 };
}
